<template>
  <div class="courses">
    <h4 class="profile-section_title">Courses</h4>
    <ul class="round-items" v-if="courses.length > 0">
      <li v-for="(course, $index) in courses" :key="$index">
        <div class="round-item">
          <router-link :to="'/course/' + course.id">
            <div class="round-items_value"><span>{{course.percents}}%</span></div>
            <div class="round-items_text">
              <div class="item-title">{{course.name}}</div>
              <div class="item-description">{{course.description}}</div>
            </div>
          </router-link>
        </div>
      </li>
    </ul>
    <ul v-else class="round-items skeleton-list">
      <li v-for="i in 2">
        <skeleton-box width="auto" height="80px" display="block" style="margin: 0.75rem 1rem;"></skeleton-box>
      </li>
    </ul>
  </div>
</template>

<script>
    import {COURSE_REQUEST, GET_USER_COURSE_DATA} from "../store/actions/course";
    import SkeletonBox from "../components/SkeletonBox";

    export default {
        name: "Courses",
        components: {SkeletonBox},
        data() {
            return {
                courses: [],
                courseData: []
            }
        },
        created() {
            this.$store.dispatch(COURSE_REQUEST);

            this.courses = this.$store.getters.getCourses;
        },
        mounted() {
            this.$store.watch(
                (state, getters) => getters.getCourses,
                (courses) => {
                    this.courses = courses;
                },
            );
        },
        methods: {}
    }
</script>

<style scoped>

</style>
